export const TRANSIENT_STEP = {
  configuration: 1,
  scenario: 0,
} as const;

export type TransientStep = (typeof TRANSIENT_STEP)[keyof typeof TRANSIENT_STEP];

export const TRANSIENT_RESPONSE_ALGORITHM = "Transient response";

export const TRANSIENT_JOB_CPU_COUNT = 32;

export const TRANSIENT_JOB_SUBTYPE = "transient_response";

export const JOB_DETAILS_TAB = {
  config: "config",
  input: "input",
  logs: "logs",
  result: "result",
  state: "state",
};

export const TRANSIENT_INPUT_FOLDER = "01_Input";

export const RESULT_KIND = {
  dictionary: "dictionary",
  hourly: "hourly",
} as const;

export type ResultKind = (typeof RESULT_KIND)[keyof typeof RESULT_KIND];

export const RESULT_KIND_FOLDER = {
  [RESULT_KIND.dictionary]: "Transient_response_simulation_parallel_dictionary",
  [RESULT_KIND.hourly]: "Transient_response_simulation_parallel",
} as const;

export const JOB_RESULTS_REFRESH_MS = 8000;
